import React from 'react'
import {IconProps} from '../../types/IconProps'

const ClipBoardIcon = ({height, width, color}: IconProps) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width || '20'}
      height={height || '20'}
      viewBox='0 0 20 20'
      fill='none'
    >
      <g clipPath='url(#clip0_2268_34551)'>
        <path
          d='M16.5131 1.66717H14.1667V1.26967C14.1667 0.568574 13.5986 0.000488281 12.8975 0.000488281H7.10248C6.40143 0.000488281 5.8333 0.568574 5.8333 1.26967V1.66717H3.4865C2.48127 1.66717 1.6665 2.48193 1.6665 3.48717V18.1805C1.6665 19.1857 2.48127 20.0005 3.4865 20.0005H16.5132C17.5184 20.0005 18.3332 19.1857 18.3332 18.1805V3.48717C18.3331 2.48193 17.5184 1.66717 16.5131 1.66717ZM7.49998 1.66717H12.4998V3.33385H7.49998V1.66717ZM16.6665 18.1805C16.6665 18.2653 16.5979 18.3338 16.5132 18.3338H3.4865C3.40174 18.3338 3.33318 18.2653 3.33318 18.1805V3.48717C3.33318 3.4024 3.40174 3.33385 3.4865 3.33385H5.83318V3.73135C5.83318 4.4324 6.40127 5.00053 7.10236 5.00053H7.10252H12.8974H12.8975C13.5986 5.00053 14.1667 4.43244 14.1667 3.73135V3.33381H16.5132C16.5979 3.33381 16.6665 3.40236 16.6665 3.48713V18.1805Z'
          fill={color || '#666666'}
          stroke={color || '#666666'}
          strokeWidth='0.00064'
        />
        <path
          d='M14.1663 7.50049H9.16633C8.70609 7.50049 8.33301 7.87357 8.33301 8.33381C8.33301 8.79404 8.70609 9.16713 9.16633 9.16713H14.1663C14.6266 9.16713 14.9996 8.79404 14.9996 8.33381C14.9996 7.87357 14.6266 7.50049 14.1663 7.50049Z'
          fill={color || '#666666'}
          stroke={color || '#666666'}
          strokeWidth='0.00064'
        />
        <path
          d='M14.1663 10.8339H9.16633C8.70609 10.8339 8.33301 11.2069 8.33301 11.6672C8.33301 12.1274 8.70609 12.5005 9.16633 12.5005H14.1663C14.6266 12.5005 14.9996 12.1274 14.9996 11.6672C14.9996 11.207 14.6266 10.8339 14.1663 10.8339Z'
          fill={color || '#666666'}
          stroke={color || '#666666'}
          strokeWidth='0.00064'
        />
        <path
          d='M14.1663 14.1671H9.16633C8.70609 14.1671 8.33301 14.5402 8.33301 15.0004C8.33301 15.4607 8.70609 15.8338 9.16633 15.8338H14.1663C14.6266 15.8338 14.9996 15.4607 14.9996 15.0004C14.9996 14.5402 14.6266 14.1671 14.1663 14.1671Z'
          fill={color || '#666666'}
          stroke={color || '#666666'}
          strokeWidth='0.00064'
        />
        <path
          d='M5.83332 7.50049C5.37332 7.50049 5 7.87381 5 8.33381C5 8.79381 5.37332 9.16713 5.83332 9.16713C6.29332 9.16713 6.66664 8.79381 6.66664 8.33381C6.66664 7.87381 6.29332 7.50049 5.83332 7.50049Z'
          fill={color || '#666666'}
          stroke={color || '#666666'}
          strokeWidth='0.00064'
        />
        <path
          d='M5.83332 10.8339C5.37332 10.8339 5 11.2072 5 11.6672C5 12.1272 5.37332 12.5005 5.83332 12.5005C6.29332 12.5005 6.66664 12.1272 6.66664 11.6672C6.66664 11.2072 6.29332 10.8339 5.83332 10.8339Z'
          fill={color || '#666666'}
          stroke={color || '#666666'}
          strokeWidth='0.00064'
        />
        <path
          d='M5.83332 14.1671C5.37332 14.1671 5 14.5404 5 15.0004C5 15.4604 5.37332 15.8338 5.83332 15.8338C6.29332 15.8338 6.66664 15.4604 6.66664 15.0004C6.66664 14.5404 6.29332 14.1671 5.83332 14.1671Z'
          fill={color || '#666666'}
          stroke={color || '#666666'}
          strokeWidth='0.00064'
        />
      </g>
      <defs>
        <clipPath id='clip0_2268_34551'>
          <rect width='20' height='20' fill='white' transform='translate(0 0.000488281)' />
        </clipPath>
      </defs>
    </svg>
  )
}

export default ClipBoardIcon
